import React from 'react'

import checkedIcon from '../../../../../../assets/checkedIcon.svg'
import uncheckedIcon from '../../../../../../assets/uncheckedIcon.svg'

function CheckboxComponent({ state, msg, onclick }) {
  const callCheckboxUpdate = () => {
    onclick(msg)
  }
  return (
    <div className="checkboxIcon">
      <img src={state ? checkedIcon : uncheckedIcon} alt="" onClick={callCheckboxUpdate} />{' '}
      <div className="checkboxMsg">{msg}</div>
    </div>
  )
}

export default CheckboxComponent
